module.exports = __webpack_public_path__ + "img/ft02.25282fb7.png";